﻿module.exports = {
    param: function(name) {
        var results = new RegExp('[\?&]' + name + '=([^&]*)').exec(window.location.href);
        return results ? decodeURI(results[1]) : null;
    },
    params: function () {
        var params = {};
        var paramsRegEx = new RegExp('[\?&]([^=]*)(?:=([^&]*))', 'g');
        var path = window.location.href;
        var matches = paramsRegEx.exec(path);
        while (matches) {
            if (matches.length >= 2) {
                var param = matches[1].replace(/^[&?]{1}/, '');
                var value = decodeURI(matches[2]);
                params[param] = value;
            }
            matches = paramsRegEx.exec(path);
        }
        return params ? params : null;
    },
    addParam: function(param, value, reloadPage = false, addToHistory = false) {
        var params = this.params();
        var queryString = '';
        var added = false;

        if (params) {
            for (var parameter in params) {
                if (queryString != '') queryString += '&';
                if (parameter.toLowerCase() == param.toLowerCase()) {
                    queryString += param + '=' + encodeURI(value);
                    added = true;
                } else {
                    queryString += parameter + '=' + encodeURI(params[parameter]);
                }
            }
            if (!added) queryString += (queryString != '' ? "&" : "") + param + '=' + encodeURI(value);
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + (queryString ? "?" + queryString : "");
            if (!reloadPage) {
                if (addToHistory && history.pushState) {
                    window.history.pushState({ path: newurl }, null, newurl);
                } else if (history.replaceState) {
                    window.history.replaceState({ path: newurl }, null, newurl);
                }
            } else {
                window.location.href = newurl;
            }
        }
    },
    queryString: function() {
        var results = new RegExp('\\?(.*)$').exec(window.location.href);
        return results ? results[1] : null;
    }
}